import React from "react"

const ListeningModule = () => (
    <section class="lrws-section-1">
        <div class="container">
        <div class="listening-wrapper mt-5">
              <div class="row">
                <div class="col-md-4">
                  <div class="listening-image-wrapper">
                    <img src={require('../../images/listening-image.png')} alt="" />
                  </div>
                </div>
                <div class="col-md-8" >
                  <div class="listening-content-wrapper">
                    <h3 class="content-title">
                      Listening
                    </h3>
                    <ul>
                      <li>
                        <span>
                          <img src={require('../../images/questions.png')} alt="" />
                          <strong>Questions : </strong> 30 min (plus 10 min transfer time)
                        </span>
                      </li>
                      <li>
                        <span>
                          <img src={require('../../images/duration.png')} alt="" />
                          <strong>Duration : </strong> 40
                        </span>
                      </li>
                    </ul>
                    <p className="note">The listening part has four sections. </p>
                    <div class="listening-sections-wrapper">
                      <p class="content-sub-title">Sections</p>
                      <div class="content-sections">
                        <div>Section 1</div>
                        <p>a conversation between two people set in an everyday social context</p>
                      </div>
                      <div class="content-sections">
                        <div>Section 2</div>
                        <p>a monologue set in an everyday social context, e.g. a speech about local facilities.</p>
                      </div>
                      <div class="content-sections">
                        <div>Section 3</div>
                        <p>a conversation between up to four people set in an educational or trainingcontext, e.g. a university tutor and a student discussing an assignment.</p>
                      </div>
                      <div class="content-sections">
                        <div>Section 4</div>
                        <p>a monologue on an academic subject, e.g. a university lecture.</p>
                      </div>
                    </div>
                    <p class="content-disclaimer">Each section has 10 questions. Each item is worth one mark.</p>
                    <div class="d-flex align-items-center">
                      <button class="trymock-btn">TRY MOCK TEST</button>
                      <div class="free-label">FREE!</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
)

export default ListeningModule
